
(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    // element.specificCellsSize = {
    //    firstCell: 'number of pixels + px'
    //    secondCell: 'number of pixels + px'
    //    lastCell: 'number of pixels + px'
    //    reAlignCells: number
    // }
    //

  function pxAlignTableCells() {
    return {
      scope: {
      },
      link: function(scope, attr,  element) {

        scope.$watch(function () {
          return  element.specificCellsSize
        }, function (val1, val2) {
          if (val1 !== val2) {
            scope.specificCellsSize = JSON.parse(element.specificCellsSize);
            alignCells()
          }
        })

        // The below code is a hagish way to make columns align up, when
        // both thead and tbody is display block. The display block 
        // is required to make the tbody scrollable while the thead
        // stays in place.
        function alignCells () {
          var thElements = document.getElementsByTagName('th');
          var tdElements = document.getElementsByTagName('td');

          for (var i = 0; i < thElements.length; i++) {
            if (tdElements[i]) {
              if (thElements[i].classList.value.includes('first-cell') && scope.specificCellsSize.firstCell) {
                thElements[i].style.width = tdElements[i].style.width = scope.specificCellsSize.firstCell;
              } else if (thElements[i].classList.value.includes('second-cell') && scope.specificCellsSize.secondCell) {
                thElements[i].style.width = tdElements[i].style.width = scope.specificCellsSize.secondCell;
              } 
              else if (thElements[i].classList.value.includes('last-cell') && scope.specificCellsSize.lastCell) {
                thElements[i].style.width = tdElements[i].style.width = scope.specificCellsSize.lastCell;
              } else {
                var widerElement = thElements[i].offsetWidth > tdElements[i].offsetWidth ? thElements[i] : tdElements[i];
                var width = window.getComputedStyle(widerElement).width;
                thElements[i].style.width = tdElements[i].style.width = width;
              }
            }
          }
        }
        

      }
    };
  }

  pxAlignTableCells.$inject = [];

  angular
    .module('printix-admin')
    .directive('pxAlignTableCells', pxAlignTableCells);

})();
